import api from "@/api/api";
import {iniciarRequisicao, logout} from "@/helpers";
import {STATUS_HTTP} from "../../statusHTTP";

const PREFIXO = 'diagnostico/slow-no-moving/indicadores/evolucao-estoque/histogramas';

export const buscarHistogramas = async (params) => {
  const url = `/${PREFIXO}`;
  const {data, status} = await api.get(url, {params, headers: iniciarRequisicao()}).catch(logout);

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data;
}

export const buscarSegmentos = async (params) => {
  const url = `/${PREFIXO}/segmentos`;
  const {data, status} = await api.get(url, {params, headers: iniciarRequisicao()}).catch(logout);

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data.segmentos;
}

export const buscarFornecedores = async (params) => {
  const url = `/${PREFIXO}/segmentos/fornecedores`;
  const {data, status} = await api.get(url, {params, headers: iniciarRequisicao()}).catch(logout);

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data.fornecedores;
}

export const buscarProdutos = async (params) => {
  const url = `/${PREFIXO}/segmentos/fornecedores/produtos`;
  const {data, status} = await api.get(url, {params, headers: iniciarRequisicao()}).catch(logout);

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data.produtos;
}

export const buscarListaColunasDiagnostico = async () => {
  const url = `/${PREFIXO}/detalhamentos/colunas`;
  const {data, status} = await api.get(url, {headers: iniciarRequisicao()}).catch(logout);

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data.colunas;
}

export const salvarListaColunasGridSlowNoMovingDiagnostico = async (params) => {
  const url = `/${PREFIXO}/detalhamentos/colunas`;
  const {data, status} = await api.post(url, params, {headers: iniciarRequisicao()}).catch(logout);

  if (status !== STATUS_HTTP.CREATED) {
    logout();
  }

  localStorage.token = data.token;
  return true;
}

export const buscarPeriodoAnalise = async () => {
  const url = `/${PREFIXO}/periodo-analise`;
  const {data, status} = await api.get(url, {headers: iniciarRequisicao()}).catch(logout);

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data;
}

export const salvarPeriodoAnalise = async (params) => {
  const url = `/${PREFIXO}/periodo-analise`;
  const {data, status} = await api.post(url, params, {headers: iniciarRequisicao()}).catch(logout);

  if (status !== STATUS_HTTP.CREATED) {
    logout();
  }

  localStorage.token = data.token;
  return true;
}
